import { Scenario, Vehicle } from '../DataTypes';

export const mockScenario: Scenario = {
  name: 'Default Scenario',
  description: {
    description: 'Test scenario description',
    wind: '0',
    temperature: '20',
    life: '100'
  },
  drivingActions: ['accelerate', 'coast', 'brake'],
  stopActions: ['stop', 'dwell']
};

export const mockVehicle: Vehicle = {
  id: 1,
  name: 'Mock Vehicle',
  version: '1.0',
  type: 'BEMU',
  scenarios: [mockScenario],
  tags: []
};

export const mockBEMUVehicle: Vehicle = {
  id: 2,
  name: 'MireoSmartBEMU',
  version: '1.0',
  type: 'BEMU',
  scenarios: [mockScenario],
  tags: []
};

export const mockHydrogenVehicle: Vehicle = {
  id: 3,
  name: 'Hydrogen Train',
  version: '1.0',
  type: 'HEMU',
  scenarios: [mockScenario],
  tags: []
};
